import CrudManager from "./CrudManager";

export default function VideosAdmin() {
  return (
    <CrudManager
      name="videos" title="Videos" subtitle="Embedded YouTube videos on the homepage"
      empty={{ title: "", video_id: "", order: 99 }}
      fields={[
        { name: "title", label: "Video title" },
        { name: "video_id", label: "YouTube video ID", hint: "e.g. dQw4w9WgXcQ (the part after v=)" },
        { name: "order", label: "Display order", type: "number" },
      ]}
      renderSummary={(v) => (
        <>
          <div className="aspect-video rounded-lg overflow-hidden bg-black mb-3">
            <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${v.video_id}`} title={v.title} />
          </div>
          <h3 className="font-medium text-sm">{v.title}</h3>
        </>
      )}
    />
  );
}
